import type React from 'react';

import { isImeComposing } from './isImeComposing';

/**
 * ADM-16-AC1。button にできない要素（中に段落や表の行の構造を持つもの）を、キーボードで
 * 押せるボタンとして扱うための属性。Tab で選べ、Enter・Space で onActivate を呼ぶ。
 *
 *   <div {...buttonLike(() => open(id), t('ui.view'))}>…</div>
 *
 * 中身が文字や画像だけのものは、この関数ではなく <button type="button"> にする。
 */
export function buttonLike(onActivate: () => void, label?: string) {
  return {
    role: 'button' as const,
    tabIndex: 0,
    onClick: () => onActivate(),
    onKeyDown: (event: React.KeyboardEvent) => {
      if (event.target !== event.currentTarget) return;
      if (isImeComposing(event)) return; // EV-120
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate();
      }
    },
    ...(label ? { 'aria-label': label } : {}),
  };
}
